import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { FaRegUser } from "react-icons/fa";
import { GoPlus } from "react-icons/go";
import { HiOutlineMenu, HiX } from "react-icons/hi";
import logo from "../../../images/logo.png";
import AuthContext from "../../../context/UserSummary";

const Navbar = () => {
  const { isLoggedIn } = useContext(AuthContext);
  const [toggle, setToggle] = useState(false);

  const decor = {
    textDecoration: "none",
  };

  return (
    <div className="navbar-wrapper">
      <Link to="/">
        <img className="logo-img" src={logo} alt="logo-img" />
      </Link>
      <div className="nav-links">
        <ul
          className={toggle ? "nav-links-mobile" : "links"}
          onClick={() => setToggle(false)}
        >
          <Link style={decor} to="/">
            <li className="home">Home</li>
          </Link>
          <Link style={decor} to="/listings">
            <li>Listings</li>
          </Link>
          <Link style={decor} to="/agents">
            <li>Agents</li>
          </Link>
          <Link style={decor} to="/about">
            <li>About</li>
          </Link>
          <Link style={decor} to="/contacts">
            <li>Contact</li>
          </Link>
        </ul>
      </div>

      <div className="nav-end">
        <div className="vertical-row"></div>
        {isLoggedIn ? null : (
          <div className="sign-in">
            <div className="user-icon">
              <FaRegUser />
            </div>
            <Link style={decor} to="/login" className="user-sign-in">
              Sign In
            </Link>
          </div>
        )}
        <div className="vertical-row"></div>

        {isLoggedIn ? (
          <Link
            style={decor}
            to="/dashboard/dashboard-home"
            className={toggle ? "added-mobile" : "added"}
            onClick={() => setToggle(false)}
          >
            <div className="add-icon">
              <GoPlus />
            </div>
            <p className="add-list">Add Listing</p>
          </Link>
        ) : null}
        <div className="vertical-row"></div>
        <div className="menu-wrapper">
          <div className="menu-div" onClick={() => setToggle(!toggle)}>
            {toggle ? (
              <HiX className="menu" />
            ) : (
              <HiOutlineMenu className="menu" />
            )}
            {/* <p className='menuu'>MENU</p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
